import AddToCartButton from '../components/AddToCartButton';
import { connect } from 'react-redux';

import {
  saveCartRequest,
  openCartForDesktop,
} from '../actions';
import {
  getPendingQuantitiesByLineItem,
  getPendingQuantity,
} from '../selectors';

const mapStateToProps = state => ({
  pendingQuantity: getPendingQuantity(state),
  pendingQuantities: getPendingQuantitiesByLineItem(state),
  lineItemsPending: state.lineItemsPending,
  isSaving: state.isSaving,
  isOpen: state.isOpen,
  variantsSaving: state.variantsSaving,
  isSubscribed: state.subscribed,
});

const mapDispatchToProps = dispatch => ({
  updateLineItems: (lineItemsPending, isCommitting) => {
    dispatch(saveCartRequest(lineItemsPending, isCommitting));
  },
  openCartForDesktop: shouldAutoClose => {
    dispatch(openCartForDesktop(shouldAutoClose));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddToCartButton);
